import * as React from "react";
import { cn } from "@/lib/utils";

interface SectionProps {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * Bounded, titled panel used to group page content, control-plane style.
 * Nested tiles/cards inside should use bg-background for a recessed look.
 */
export function Section({ title, action, children, className }: SectionProps) {
  return (
    <section
      className={cn(
        "rounded-sm border border-border bg-card shadow-base",
        className
      )}
    >
      <header className="flex items-center border-b border-border px-5 py-3">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          {title}
        </h2>
        <div className="flex-1" />
        {action}
      </header>
      <div className="p-5">{children}</div>
    </section>
  );
}
